import { techCategories } from "../data/techCategories";

export default function Toolkit() {
  return (
    <section id="toolkit" className="t-sec" aria-labelledby="toolkit-title">
      <div className="t-wrap">
        <div className="t-block-head">
          <h2 id="toolkit-title" className="t-h2 t-rise">
            Works with your stack.
          </h2>
        </div>

        <div className="t-ledger t-rise">
          {techCategories.map((category) => (
            <div key={category.title} className="t-ledger__row">
              <span className="t-ledger__cat">{category.title}</span>
              <span className="t-ledger__items">
                {category.items.map((item) => item.name).join(" · ")}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
